document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  // Автозаполнение из query
  const phone = urlParams.get("phone");
  if (phone) document.getElementById("phone").value = phone;
  const invoiceNumber = urlParams.get("invoiceNumber");
  if (invoiceNumber) document.getElementById("invoiceNumber").value = invoiceNumber;

  // Логика взаимного блокирования invoiceNumber и customerOrderedBefore
  const invoiceNumberInput = document.getElementById('invoiceNumber');
  const customerOrderedBeforeCheckbox = document.getElementById('customerOrderedBefore');
  const customerOrderedBeforeLabel = customerOrderedBeforeCheckbox ? customerOrderedBeforeCheckbox.closest('label') : null;

  if (invoiceNumberInput && customerOrderedBeforeCheckbox) {
    // Если чекбокс customerOrderedBefore отмечен, блокируем invoiceNumber
    customerOrderedBeforeCheckbox.addEventListener('change', function () {
      if (this.checked) {
        invoiceNumberInput.disabled = true;
        invoiceNumberInput.value = '';
        invoiceNumberInput.style.opacity = '0.5';
      } else {
        invoiceNumberInput.disabled = false;
        invoiceNumberInput.style.opacity = '1';
      }
    });

    // Если в invoiceNumber появляется значение, блокируем чекбокс customerOrderedBefore
    invoiceNumberInput.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '');
      if (this.value.trim() !== '') {
        customerOrderedBeforeCheckbox.disabled = true;
        customerOrderedBeforeCheckbox.checked = false;
        if (customerOrderedBeforeLabel) {
          customerOrderedBeforeLabel.style.opacity = '0.5';
          customerOrderedBeforeLabel.style.pointerEvents = 'none';
        }
      } else {
        customerOrderedBeforeCheckbox.disabled = false;
        if (customerOrderedBeforeLabel) {
          customerOrderedBeforeLabel.style.opacity = '';
          customerOrderedBeforeLabel.style.pointerEvents = '';
        }
      }
    });

    // Проверка после автозаполнения из query параметров
    if (invoiceNumberInput.value.trim() !== '') {
      customerOrderedBeforeCheckbox.disabled = true;
      customerOrderedBeforeCheckbox.checked = false;
      if (customerOrderedBeforeLabel) {
        customerOrderedBeforeLabel.style.opacity = '0.5';
        customerOrderedBeforeLabel.style.pointerEvents = 'none';
      }
    }
  }

  document.getElementById("newCustomerForm").addEventListener("submit", async function (e) {
    e.preventDefault();
    const form = this;
    const formData = new FormData(form);

    // Собираем все значения
    const payload = Object.fromEntries(formData.entries());

    // Чекбоксы termsApproved и acceptsAdvertising
    payload.termsApproved = form.querySelector("input[name='termsApproved']").checked;
    payload.acceptsAdvertising = form.querySelector("input[name='acceptsAdvertising']").checked;

    // Чекбокс customerOrderedBefore
    payload.customerOrderedBefore = form.querySelector("input[name='customerOrderedBefore']").checked;

    // Валидация обязательных полей
    // invoiceNumber обязателен только если customerOrderedBefore не отмечен
    const invoiceNumberRequired = !payload.customerOrderedBefore;
    const missingFields = [];

    if (!payload.phone) missingFields.push("מספר טלפון");
    if (invoiceNumberRequired && !payload.invoiceNumber) missingFields.push("מספר חשבונית");
    if (!payload.firstName) missingFields.push("שם פרטי");
    if (!payload.lastName) missingFields.push("שם משפחה");
    if (!payload.gender) missingFields.push("מין");
    if (!payload.termsApproved) missingFields.push("אישור תקנון");

    if (missingFields.length > 0) {
      alert("נא למלא את כל השדות החובה: " + missingFields.join(", "));
      return;
    }

    // Валидация email (если указан)
    if (payload.email && payload.email.trim() !== '') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(payload.email)) {
        alert("נא להזין כתובת אימייל תקינה");
        return;
      }
    }

    // Обработка номера телефона: оставляем только последние 9 цифр и добавляем 0 в начало
    const phoneDigits = payload.phone.replace(/[^0-9]/g, '');
    if (phoneDigits.length < 9) {
      alert("נא להזין מספר טלפון תקין");
      return;
    }

    // Берем последние 9 цифр и добавляем 0 в начало
    const last9Digits = phoneDigits.slice(-9);
    payload.phone = '0' + last9Digits;

    try {
      // Отправить данные на backend для регистрации нового клиента
      const res = await fetch("http://vip.pozylov.co.il/apps/customer-register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        const result = await res.json();
        alert("הרשמה הושלמה!");
        form.reset();
      } else {
        const errorData = await res.json().catch(() => ({}));
        alert(`שגיאה בהרשמה: ${errorData.error || res.statusText}`);
      }
    } catch (error) {
      console.error("Error during registration:", error);
      alert("שגיאה בהרשמה - נא לנסות שוב");
    }
  });
});